/* eslint-disable */
export default {
  rateExceeded:
    'Limite de demandes dépassée. L’application reprendra dans {ttl} secondes.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
